export default {
  MEETING_API: `http://localhost:5001/conference`,
  WSS: 'ws://localhost:3001',
  SIGNED_API: 'https://jbcl4wrbu6.execute-api.us-east-1.amazonaws.com/conference',
  STREAM_API: `http://localhost:5005/conference`,
  QUESTIONS_CF_API: 'https://d37l7zt1z6147j.cloudfront.net',
};
